import { Controller } from "@hotwired/stimulus"

// The send form's small helpers (spec 2026-10-23): what the chosen asset's
// balance is, Send all, and the one warning — sending USDC that the next
// pull needs. The signing itself is the approval controller next to it.
export default class extends Controller {
  static targets = [ "asset", "amount", "ticker", "held", "warning" ]
  static values = { nextPull: Number }

  connect() {
    this.refresh()
  }

  get chosen() {
    return this.assetTargets.find((radio) => radio.checked) || this.assetTargets[0]
  }

  refresh() {
    const asset = this.chosen
    if (!asset) return
    const held = Number(asset.dataset.held)
    const decimals = Number(asset.dataset.decimals)
    this.tickerTarget.textContent = asset.dataset.ticker
    this.heldTarget.textContent = `${this.format(held, decimals)} ${asset.dataset.ticker}`
    this.amountTarget.step = `0.${"0".repeat(Math.max(decimals - 1, 0))}1`

    if (this.hasWarningTarget) {
      const amount = Number(this.amountTarget.value) || 0
      const usdc = asset.value === "usdc"
      this.warningTarget.hidden = !(usdc && amount > 0 && held - amount < this.nextPullValue)
    }
  }

  all() {
    const asset = this.chosen
    if (!asset) return
    this.amountTarget.value = asset.dataset.held
    this.refresh()
  }

  // Enter in a field must not submit the form: the Send button signs.
  block(event) {
    event.preventDefault()
  }

  format(value, decimals) {
    return value.toLocaleString("en-US", { maximumFractionDigits: Math.min(decimals, 6) })
  }
}
